import{isSafari as t}from"react-device-detect";function o(){return!(t&&window.location.origin.startsWith("http://localhost"))}export{o as getSecureMode};
